/*

  Product names and service plan identifiers for licensing
  Derived from https://docs.microsoft.com/en-us/azure/active-directory/users-groups-roles/licensing-service-plan-reference

  Licenses for a user can be viewed on /about page, or by using graph
  explorer (https://developer.microsoft.com/en-us/graph/graph-explorer)
  with query: https://graph.microsoft.com/v1.0/me/?$select=assignedLicenses,assignedPlans

*/
export namespace O365Licenses {
  export const AUDIO_CONFERENCING = '0c266dff-15dd-4b49-8397-2bb16070ed52';
  export const AZURE_ACTIVE_DIRECTORY_BASIC = '2b9c8e7c-319c-43a2-a2a0-48c5c6161de7';
  export const AZURE_ACTIVE_DIRECTORY_PREMIUM_P1 = '078d2b04-f1bd-4111-bbd4-b4b1b354cef4';
  export const AZURE_ACTIVE_DIRECTORY_PREMIUM_P2 = '84a661c4-e949-4bd2-a560-ed7766fcaf2b';
  export const AZURE_INFORMATION_PROTECTION_PLAN_1 = 'c52ea49f-fe5d-4e95-93ba-1de91d380f89';
  export const DYNAMICS_365_CUSTOMER_ENGAGEMENT_PLAN_ENTERPRISE_EDITION = 'ea126fc5-a19e-42e2-a731-da9d437bffcf';
  export const DYNAMICS_365_FOR_CUSTOMER_SERVICE_ENTERPRISE_EDITION = '749742bf-0d37-4158-a120-33567104deeb';
  export const DYNAMICS_365_FOR_FINANCIALS_BUSINESS_EDITION = 'cc13a803-544e-4464-b4e4-6d6169a138fa';
  export const DYNAMICS_365_FOR_SALES_AND_CUSTOMER_SERVICE_ENTERPRISE_EDITION = '8edc2cf8-6438-4fa9-b6e3-aa1660c640cc';
  export const DYNAMICS_365_FOR_SALES_ENTERPRISE_EDITION = '1e1a282c-9c54-43a2-9310-98ef728faace';
  export const DYNAMICS_365_FOR_TEAM_MEMBERS_ENTERPRISE_EDITION = '8e7a3d30-d97d-43ab-837c-d7701cef83dc';
  export const DYNAMICS_365_UNF_OPS_PLAN_ENT_EDITION = 'ccba3cfe-71ef-423a-bd87-b6df3dce59a9';
  export const ENTERPRISE_MOBILITY_SECURITY_E3 = 'efccb6f7-5641-4e0e-bd10-b4976e1bf68e';
  export const ENTERPRISE_MOBILITY_SECURITY_E5 = 'b05e124f-c7cc-45a0-a6aa-8cf78c946968';
  export const EXCHANGE_ONLINE_PLAN_1 = '4b9405b0-7788-4568-add1-99614e613b69';
  export const EXCHANGE_ONLINE_PLAN_2 = '19ec0d23-8335-4cbd-94ac-6050e30712fa';
  export const EXCHANGE_ONLINE_ARCHIVING_FOR_EXCHANGE_ONLINE = 'ee02fd1b-340e-4a4b-b355-4a514e4c8943';
  export const EXCHANGE_ONLINE_ARCHIVING_FOR_EXCHANGE_SERVER = '90b5e015-709a-4b8b-b08e-3200f994494c';
  export const EXCHANGE_ONLINE_ESSENTIALS = '7fc0182e-d107-4556-8329-7caaa511197b';
  export const EXCHANGE_S_ONLINE_ESSENTIALS = 'e8f81a67-bd96-4074-b108-cf193eb9433b';
  export const EXCHANGE_ONLINE_KIOSK = '80b2d799-d2ba-4d2a-8842-fb0d0f3a4b82';
  export const EXCHANGE_ONLINE_POP = 'cb0a98a8-11bc-494c-83d9-c1b1ac65327e';
  export const INTUNE = '061f9ace-7d42-4136-88ac-31dc755f143f';
  export const MICROSOFT_365_BUSINESS = 'cbdc14ab-d96c-4c30-b9f4-6ada7cdc1d46';
  export const MICROSOFT_365_E3 = '05e9a617-0261-4cee-bb44-138d3ef5d965';
  export const MICROSOFT_DYNAMICS_CRM_ONLINE_BASIC = '906af65a-2970-46d5-9b58-4e9aa50f0657';
  export const MICROSOFT_DYNAMICS_CRM_ONLINE = 'd17b27af-3f49-4822-99f9-56a661538792';
  export const MICROSOFT_INTUNE_A_DIRECT = '061f9ace-7d42-4136-88ac-31dc755f143f';
  export const MS_IMAGINE_ACADEMY = 'ba9a34de-4489-469d-879c-0f0f145321cd';
  export const OFFICE_365_BUSINESS = 'cdd28e44-67e3-425e-be4c-737fab2899d3';
  export const SMB_BUSINESS = 'b214fe43-f5a3-4703-beeb-fa97188220fc';
  export const O365_BUSINESS_ESSENTIALS = '3b555118-da6a-4418-894f-7df1e2096870';
  export const SMB_BUSINESS_ESSENTIALS = 'dab7782a-93b1-4074-8bb1-0e61318bea0b';
  export const O365_BUSINESS_PREMIUM = 'f245ecc8-75af-4f8e-b61f-27d8114de5f3';
  export const SMB_BUSINESS_PREMIUM = 'ac5cef5d-921b-4f97-9ef3-c99076e5470f';
  export const OFFICE_365_ENTERPRISE_E1 = '18181a46-0d4e-45cd-891e-60aabd171b4e';
  export const OFFICE_365_ENTERPRISE_E2 = '6634e0ce-1a9f-428c-a498-f84ec7b8aa2e';
  export const OFFICE_365_ENTERPRISE_E3 = '6fd2c87f-b296-42f0-b197-1e91e994b900';
  export const OFFICE_365_ENTERPRISE_E3_DEVELOPER = '189a915c-fe4f-4ffa-bde4-85b9628d07a0';
  export const OFFICE_365_ENTERPRISE_E4 = '1392051d-0cb9-4b7a-88d5-621fee5e8711';
  export const OFFICE_365_ENTERPRISE_E5 = 'c7df2760-2c81-4ef7-b578-5b5392b571df';
  export const OFFICE_365_ENTERPRISE_E5_WITHOUT_AUDIO_CONFERENCING = '26d45bd9-adf1-46cd-a9e1-51e9a5524128';
  export const OFFICE_365_F1 = '4b585984-651b-448a-9e53-3b10f069cf7f';
  export const OFFICE_365_MIDSIZE_BUSINESS = '04a7fb0d-32e0-4241-b4f5-3f7618cd1162';
  export const OFFICE_365_PROPLUS = 'c2273bd0-dff7-4215-9ef5-2c7bcfb06425';
  export const OFFICE_365_SMALL_BUSINESS = 'bd09678e-b83c-4d3f-aaba-3dad4abd128b';
  export const OFFICE_365_SMALL_BUSINESS_PREMIUM = 'fc14ec4a-4169-49a4-a51e-2c852931814b';
  export const ONEDRIVE_FOR_BUSINESS_PLAN_1 = 'e6778190-713e-4e4f-9119-8b8238de25df';
  export const ONEDRIVE_FOR_BUSINESS_PLAN_2 = 'ed01faf2-1d88-4947-ae91-45ca18703a96';
  export const POWER_BI_FOR_OFFICE_365_ADD_ON = '45bc2c81-6072-436a-9b0b-3b12eefbc402';
  export const POWER_BI_PRO = 'f8a1db68-be16-40ed-86d5-cb42ce701560';
  export const POWER_BI_FREE = 'a403ebcc-fae0-4ca2-8c8c-7a907fd6c235';
  export const PROJECT_FOR_OFFICE_365 = 'a10d5e58-74da-4312-95c8-76be4e5b75a0';
  export const PROJECT_ONLINE_ESSENTIALS = '776df282-9fc0-4862-99e2-70e561b9909e';
  export const PROJECT_ONLINE_PREMIUM = '09015f9f-377f-4538-bbb5-f75ceb09358a';
  export const PROJECT_ONLINE_PREMIUM_WITHOUT_PROJECT_CLIENT = '2db84718-652c-47a7-860c-f10d8abbdae3';
  export const PROJECT_ONLINE_PROFESSIONAL = '53818b1b-4a27-454b-8896-0dba576410e6';
  export const PROJECT_ONLINE_WITH_PROJECT_FOR_OFFICE_365 = 'f82a60b8-1ee3-4cfb-a4fe-1c6a53c2656c';
  export const SHAREPOINT_ONLINE_PLAN_1 = '1fc08a02-8b3d-43b9-831e-f76859e04e1a';
  export const SHAREPOINT_ONLINE_PLAN_2 = 'a9732ec9-17d9-494c-a51c-d6b45b384dcb';
  export const SKYPE_FOR_BUSINESS_CLOUD_PBX = 'e43b5b99-8dfb-405f-9987-dc307f34bcbd';
  export const SKYPE_FOR_BUSINESS_ONLINE_PLAN_1 = 'b8b749f8-a4ef-4887-9539-c95b1eaa5db7';
  export const SKYPE_FOR_BUSINESS_ONLINE_PLAN_2 = 'd42c793f-6c78-4f43-92ca-e8f6a02b035f';
  export const SKYPE_FOR_BUSINESS_PSTN_CONFERENCING = '0c266dff-15dd-4b49-8397-2bb16070ed52';
  export const SKYPE_FOR_BUSINESS_PSTN_DOMESTIC_AND_INTERNATIONAL_CALLING = 'd3b4fe1f-9992-4930-8acb-ca6ec609365e';
  export const SKYPE_FOR_BUSINESS_PSTN_DOMESTIC_CALLING = '0dab259f-bf13-4952-b7f8-7db8f131b28d';
  export const SKYPE_FOR_BUSINESS_PSTN_DOMESTIC_CALLING_120_MINUTES = '54a152dc-90de-4996-93d2-bc47e670fc06';
  export const VISIO_ONLINE_PLAN_1 = '4b244418-9658-4451-a2b8-b5e2b364e9bd';
  export const VISIO_Online_Plan_2 = 'c5928f49-12ba-48f7-ada3-0d743a3601d5';
  export const Microsoft_365_E5 = '06ebc4ee-1bb5-47dd-8120-11324bc54e06';
  export const Microsoft_365_E3_USGOV_DOD = 'd61d61cc-f992-433f-a577-5bd016037eeb';
  export const Microsoft_365_E3_USGOV_GCCHIGH = 'ca9d1dd9-dfe9-4fef-b97c-9bc1ea3c3658';
  export const Microsoft_365_F1 = '66b55226-6b4f-492c-910c-a3b7a3c9d993';
  export const Office_365_E3_USGOV_DOD = 'b107e5a3-3e60-4c0d-a184-a7e4395eb44c';
  export const Office_365_E3_USGOV_GCCHIGH = 'aea38a85-9bd5-4981-aa00-616b411205bf';
  export const WINDOWS_10_ENTERPRISE_E3 = 'cb10e6cd-9da4-4992-867b-67546b1db821';
  export const CRMPLAN1 = '119cf168-b6cf-41fb-b82e-7fee7bae5814';
  export const CRMPLAN2 = 'bf36ca64-95c6-4918-9275-eb9f4ce2c04f';
  export const CRMSTANDARD = 'f9646fb2-e3b2-4309-95de-dc4833737456';
  export const DYN365_ENTERPRISE_CUSTOMER_SERVICE = '99340b49-fb81-4b1e-976b-8f2ae8e9394f';
  export const DYN365_ENTERPRISE_P1 = 'd56f3deb-50d8-465a-bedb-f079817ccac1';
  export const DYN365_ENTERPRISE_P1_IW = '056a5f80-b4e0-4983-a8be-7ad254a113c9';
  export const DYN365_ENTERPRISE_SALES = '2da8e897-7791-486b-b08f-cc63c8129df7';
  export const DYN365_ENTERPRISE_TEAM_MEMBERS = '6a54b05e-4fab-40e7-9828-428db3b336fa';
  export const EMPLOYEE_SELF_SERVICE = 'ba5f0cfa-d54a-4ea0-8cf4-a7e1dc4423d8';
  export const EXCHANGE_B_STANDARD = '90927877-dcff-4af6-b346-2332c0b15bb7';
  export const EXCHANGE_L_STANDARD = 'd42bdbd6-c335-4231-ab3d-c8f348d5aff5';
  export const EXCHANGE_S_ARCHIVE = 'da040e0a-b393-4bea-bb76-928b3fa1cf5a';
  export const EXCHANGE_S_DESKLESS = '4a82b400-a79f-41a4-b4e2-e94f5787b113';
  export const EXCHANGE_S_ENTERPRISE = 'efb87545-963c-4e0d-99df-69c6916d9eb0';
  export const EXCHANGE_S_ESSENTIALS = '1126bef5-da20-4f07-b45e-ad25d2581aa8';
  export const EXCHANGE_S_STANDARD = '9aaf7827-d63c-4b61-89c3-182f06f82e5c';
  export const EXCHANGE_S_STANDARD_MIDMARKET = 'fc52cc4b-ed7d-472d-bbe7-b081c23ecc56';
  export const INTUNE_A = 'c1ec4a95-1f05-45b3-a911-aa3fa01094f5';
  export const INTUNE_A_VL = '3e170737-c728-4eae-bbb9-3f3360f7184c';
  export const INTUNE_B = '2dc63b8a-df3d-448f-b683-8655877c9360';
  export const ONEDRIVEENTERPRISE = 'afcafa6a-d966-4462-918c-ec0b4e0fe642';
  export const SHAREPOINT_S_DEVELOPER = 'a361d6e2-509e-4e25-a8ad-950060064ef4';
  export const SHAREPOINTDESKLESS = '902b47e5-dcb2-4fdc-858b-c63a90a2bdb9';
  export const SHAREPOINTENTERPRISE = '5dbe027f-2339-4123-9542-606e4d348a72';
  export const SHAREPOINTENTERPRISE_EDU = '63038b2c-28d0-45f6-bc36-33062963b498';
  export const SHAREPOINTENTERPRISE_MIDMARKET = '6b5b6a67-fc72-4a1f-a2b5-beecf05de761';
  export const SHAREPOINTLITE = 'a1f3d0a8-84c0-4ae0-bae4-685917b8ab48';
  export const SHAREPOINTSTANDARD = 'c7699d2e-19aa-44de-8edf-1736da088ca1';
  export const SHAREPOINTSTANDARD_EDU = '0a4983bb-d3e5-4a09-95d8-b2d0127b3df5';
  export const SHAREPOINTSTANDARD_YAMMERSHADOW = '4c9efd0c-8de7-4c71-8295-9f5fdb0dd048';
  export const MCOIMP = 'afc06cb0-b4f4-4473-8286-d644f70d8faf';
  export const MCOSTANDARD_MIDMARKET = 'b2669e95-76ef-4e7e-a367-002f60a39f3e';
  export const MCOSTANDARD = '0feaeb32-d00e-4d66-bd5a-43b5b83db82c';
  export const MCOLITE = '70710b6b-3ab4-4a38-9f6d-9f169461650a';
  export const MCOPSTN1 = '4ed3ff63-69d7-4fb7-b984-5aec7f605ca8';
  export const MCOPSTN2 = '5a10155d-f5c1-411a-a8ec-e99aae125390';
  export const MCOPSTN5 = '54a152dc-90de-4996-93d2-bc47e670fc06';
  export const YAMMER_ENTERPRISE = '7547a3fe-08ee-4ccb-b430-5077c5041653';
  export const YAMMER_EDU = '2078e8df-cff6-4290-98cb-5408261a760a';
  export const YAMMER_MIDSIZE = '41bf139a-4e60-409f-9346-a1361efc6dfb';
}
